import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GlobalConstants } from '../global-constants';

export interface LoginResponse {
  status: string;
  customer_id?: string;
  customer_name?: string;
  token?: string;
  message?: string;
}

export interface OtpCheckResponse {
  status: string;
}

const JSON_HEADERS = { 'Content-type': 'application/json' };

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  constructor(private http: HttpClient) {}

  // Session, backed by localStorage

  isLoggedIn(): boolean {
    return localStorage.getItem('customer_id') !== null;
  }

  getCustomerId(): string {
    return localStorage.getItem('customer_id') || '';
  }

  getCustomerName(): string {
    return localStorage.getItem('customer_name') || '';
  }

  getToken(): string | null {
    return localStorage.getItem('token');
  }

  setSession(customerId: string | undefined, customerName: string | undefined, token: string | undefined): void {
    localStorage.setItem('customer_id', customerId ?? '');
    localStorage.setItem('customer_name', customerName ?? '');
    localStorage.setItem('token', token ?? '');
  }

  clearSession(): void {
    localStorage.removeItem('customer_id');
    localStorage.removeItem('customer_name');
    localStorage.removeItem('token');
  }

  login(phone: string, password: string): Observable<LoginResponse> {
    const body = {
      title: 'Login',
      logindat: { data: [{ phone, password }] }
    };
    return this.http.post<LoginResponse>(GlobalConstants.apiURL + 'checkcustomer', body, { headers: JSON_HEADERS });
  }

  register(name: string, mobile: string, email: string, password: string): Observable<LoginResponse> {
    const body = {
      title: 'Register',
      regdata: { data: [{ name, mobile, email, password }] }
    };
    return this.http.post<LoginResponse>(GlobalConstants.apiURL + 'register', body, { headers: JSON_HEADERS });
  }

  forgotPassword(phone: string): Observable<{ status: string }> {
    const body = { title: 'Forgot Password', phone };
    return this.http.post<{ status: string }>(GlobalConstants.apiURL + 'resetpassword', body, { headers: JSON_HEADERS });
  }

  // Generates a 6-digit OTP client-side and asks the backend to text it to `mobile`.
  // Returns the generated code (kept only so callers can log/display it if needed;
  // verification of what the user typed happens server-side via checkOtp()).
  sendOtp(mobile: string): Observable<any> {
    const otp = Math.floor(100000 + Math.random() * 900000);
    const body = {
      title: 'otp',
      message: `${otp} is your OTP for TruLink`,
      customer_phone: mobile
    };
    return this.http.post(GlobalConstants.apiURL + 'sendsms', body, { headers: JSON_HEADERS });
  }

  checkOtp(mobile: string, otp: string): Observable<boolean> {
    const body = { mobile, otp };
    return this.http.post<OtpCheckResponse>(GlobalConstants.apiURL + 'otp_check', body, { headers: JSON_HEADERS }).pipe(
      map(response => !!response && response.status === 'success')
    );
  }

  validatePhone(number: string): boolean {
    return /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/.test(number);
  }
}
